import { render, staticRenderFns } from "./AliasDomains.vue?vue&type=template&id=96f0aeea&"
import script from "./AliasDomains.vue?vue&type=script&lang=js&"
export * from "./AliasDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports